<template>
    <div class="d-inline-block">
        <input ref="input" class="single-file-select-input" type="file"  @change="onFileChange"/>
        <slot :openFileSelect="openFileSelect"></slot>
    </div>
</template>

<script>
import loadImage from 'blueimp-load-image';
import Constants from '../../constants';
import promptConfirm from '../../mixins/prompt-confirm';

export default {
    mixins: [promptConfirm],
    props: {
        mimeTypes: { type: Array, required: false},
        maxImageWidth: { type: Number, required: false},
        maxImageHeight: { type: Number, required: false}
    },
    data() {
        return {
            file: null, // FileObject
            compressedImageData: null,
            imageSize: null
        }
    },
    methods: {
        openFileSelect() {
            this.$refs['input'].click();
        },
        getMatchedMimeType(type) {
            for(var i = 0; i < this.mimeTypes.length ; i++) {
                const mime = this.mimeTypes[i];
                if (mime.indexOf('/') > 0 && mime === type) {
                    return mime;
                } else if(type.indexOf(mime) >= 0) {
                    return mime;
                }
            }
            return null;
        },
        onFileChange() {
            let input = this.$refs['input'];
            if (input.files.length === 0) {
                return;
            }

            let file = input.files[0];

            if (this.mimeTypes && !this.getMatchedMimeType(file.type)) {
                this.promptAlert(this.$t('mime_type_not_supported', this.mimeTypes.join(',')));
                return;
            }

            let sizeMB = Math.round(file.size / 1000000 * 10) / 10;
            if (sizeMB > Constants.Defaults.MaxUploadFileSizeMB) {
                this.promptAlert(this.$t('message.file_should_smaller_than_25_mb', { fileName: file.name, size: sizeMB}));
                return;
            }

            if (file.type.indexOf('image') >= 0) {
                // If it's image, try load and compress image
                this.loadImageWithOrientationFixed(file, (canvas) => {
                    this.imageSize = {width: canvas.width, height: canvas.height};
                    this.compressedImageData = canvas.toDataURL(file.type, 0.9);
                    this.$emit('image-selected', {
                        data: this.compressedImageData,
                        size: this.imageSize,
                        file: this.file
                    });
                });
            }
            this.file = file;
            this.$emit('file-selected', file);
        },
        loadImageWithOrientationFixed(file, cb) {
            loadImage(file, cb, {
                canvas: true,
                orientation: true,
                maxWidth: this.imageMaxLength,
                maxHeight: this.imageMaxLength
            });
        },
    }
}
</script>

<style scoped lang="scss">

input {
    display: none;
}

</style>

<i18n>
    {
        "zh": {
            "mime_type_not_supported": "不支援此檔案類型"
        },
        "en": {
            "mime_type_not_supported": "Unsupported file type"
        }
    }
</i18n>